import { createContext, useContext, useEffect, type PropsWithChildren } from 'react';

import { Spin } from 'antd';

import { useGetFeaturesFlagsQuery, type TFeatureFlags } from '@/api/endpoints/featureFlags';
import { setFeatureFlagsGlobalState } from '@/shared/helpers';

const FeatureFlagsContext = createContext<TFeatureFlags | undefined>(undefined);

export const FeatureFlagsProvider = ({ children }: PropsWithChildren) => {
  const { data: featureFlagsData, isLoading } = useGetFeaturesFlagsQuery();

  useEffect(() => {
    if (featureFlagsData) {
      setFeatureFlagsGlobalState(featureFlagsData);
    }
  }, [featureFlagsData]);

  if (isLoading) {
    return (
      <Spin
        fullscreen
        size="large"
      />
    );
  }

  return <FeatureFlagsContext.Provider value={featureFlagsData}>{children}</FeatureFlagsContext.Provider>;
};

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}
